(function() {
    'use strict';

    var defaults = {
        closeOnOuterClick: true,
        closeOnNavigate: true,
        closingClass: '.lightbox_close',
        cssClass: '',
        delay: 0,
        focusClass: '',
        openClass: 'open',
        overFullPage: true,
        blockScroll: true,
        onClose: Odigeo._.noop,
    };

    var CONS = {
        animationTime: 100,
    };

    Odigeo.UIElements.lightboxes = [];

    Odigeo.UIElements.Lightbox = function($container, options) {
        this.$container = $container;
        this.opts = Odigeo._.extend({}, defaults, options);

        if (this.opts.overFullPage) {
            this.attachToMainPage();
        }

        this.$container.addClass(this.opts.cssClass);
        this.bindEvents();
    };

    Odigeo._.extend(Odigeo.UIElements.Lightbox.prototype, {

        bindEvents: function() {
            var evList = [
                {
                    name: 'tap',
                    selector: this.opts.closingClass,
                    handler: 'onTapClosingClass',
                },
            ];

            Odigeo._.each(evList, function(evObj) {
                if (!Odigeo._.isUndefined(evObj.selector)) {
                    this.$container.on(Odigeo.Events[evObj.name], evObj.selector, Odigeo._.bind(this[evObj.handler], this));
                } else {
                    this.$container.on(evObj.name, Odigeo._.bind(this[evObj.handler], this));
                }
            }, this);

            if (this.opts.closeOnOuterClick) {
                this.enableCloseOnOuterClick();
            }
            if (this.opts.closeOnNavigate) {
                this.enableCloseOnNavigate();
            }
        },

        toggle: function(isOpen, newDelay) {
            var currentDelay = !Odigeo._.isUndefined(newDelay) && !Odigeo._.isNull(newDelay) ? newDelay : this.opts.delay;
            Odigeo._.delay(Odigeo._.bind(function() {
                this.$container.toggleClass(this.opts.openClass, isOpen);
                this.setFocus(this.opts.focusClass);
                if (this.opts.blockScroll) {
                    this.toggleMainPageScroll(isOpen);
                }
            }, this), currentDelay);
            this.toggleList(isOpen);
            this.notify(isOpen ? 'open' : 'close');
        },

        toggleList: function(isOpen) {
            if (isOpen) {
                Odigeo.UIElements.lightboxes.push(this.$container);
            } else {
                Odigeo.UIElements.lightboxes = Odigeo._.without(this.lightboxes, this.$container);
            }
        },

        remove: function(newDelay) {
            var currentDelay = !Odigeo._.isUndefined(newDelay) && !Odigeo._.isNull(newDelay) ? newDelay : this.opts.delay;
            Odigeo._.delay(Odigeo._.bind(function() {
                this.$container.remove();
                if (this.opts.blockScroll) {
                    this.toggleMainPageScroll(false);
                }
            }, this), currentDelay);
            this.toggleList(false);
            this.notify('remove');
        },

        isOpen: function() {
            return this.$container.hasClass(this.opts.openClass);
        },

        onTapClosingClass: function(e) {
            this.toggle(false, 0);
            this.opts.onClose(e);
            this.$container.removeClass(this.opts.cssClass);
        },

        setFocus: function(targetClass) {
            if (targetClass) {
                Odigeo._.delay(Odigeo._.bind(function() {
                    this.$container.find(targetClass).focus();
                }, this), CONS.animationTime);
            }
        },

        enableCloseOnOuterClick: function() {
            this.$container.on(Odigeo.Events.tap, Odigeo._.bind(function(e) {
                if ($(e.target).is(this.$container)) {
                    this.onTapClosingClass(e);
                }
            }, this));
        },

        enableCloseOnNavigate: function() {
            this.$container.on('lightbox:closeOnNavigate', Odigeo._.bind(this.remove, this));
        },

        attachToMainPage: function() {
            this.$container.detach().appendTo(Odigeo.Device.getViewport());
        },

        notify: function(event) {
            this.trigger('lightbox:' + event);
        },

        toggleMainPageScroll: function(isDisabling) {
            Odigeo.Device.getViewport().toggleClass('od-viewport-no-vertical-scroll', isDisabling);
        },

    }, Backbone.Events);
}());
